import { API_BASE_URL } from "../configuration/config";
import { StatusCodes } from "http-status-codes";
import { BaseService } from "./base-service";
import { getString } from "common/ui_string_labels/ui-strings-utils";

const getStringPath: string = "services.csrf-service";

const CSRF_FETCH_PATH: string = "/csrf";

/**
 * Class to obtain CSRF tokens
 */
export class CSRFService extends BaseService {
    /**
     * Creates a new instance of CSRFService
     */
    constructor() {
        super(API_BASE_URL);
    }

    /**
     * Gets a CSRF token from the backend API
     * @returns {Promise} that resolves to the CSRF token string
     * @throws Error if the API request fails
     */
    public async getToken(): Promise<string> {
        const response = await this.fetch(CSRF_FETCH_PATH);
        if (response.status !== StatusCodes.OK) {
            throw new Error(getString(`${getStringPath}.failedFetch`));
        }
        const jsonResponse = await response.json();
        return jsonResponse.token as string;
    }
}
